export enum SortDirections {
  ASC = 'asc',
  DSC = 'dsc'
}

export enum CollectPageTypes {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
